/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContacts = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H4v-3H2v-2h2v-2H2v-2h2v-2H2V9h2V7H2V5h2V2zm-2 2H6v16h14zm-6 9a4 4 0 0 1 3.995 3.8L18 17v2h-2v-2a2 2 0 0 0-1.85-1.995L14 15h-2a2 2 0 0 0-1.995 1.85L10 17v2H8v-2a4 4 0 0 1 3.8-3.995L12 13zm-1-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgContacts as Contacts };
